import EditIcon from 'assets/ver2/icons/edit-document-upload-icon.svg';
import styled from 'styled-components';

const FormInputUploadDocumentsFileUploadedMask = ({ name, imgSrc }) => {
  return (
    <FormInputUploadDocumentsFileUploadedMaskStyled>
      <UploadedImageMask />
      <UploadedImage name={name} src={imgSrc} />
      <ActionImage src={EditIcon} />
    </FormInputUploadDocumentsFileUploadedMaskStyled>
  );
};

const FormInputUploadDocumentsFileUploadedMaskStyled = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

const UploadedImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  position: absolute;
`;
const UploadedImageMask = styled.div`
  width: 100%;
  height: 100%;
  background: #0000004d;
  opacity: 0.5;
  border-radius: 10px;
  position: absolute;
`;
const ActionImage = styled.img`
  width: 30px;
  height: 30px;
  position: absolute;
  top: 10px;
  right: 10px;
`;

export default FormInputUploadDocumentsFileUploadedMask;
